<template>
  <!-- name: '我要捐 快捷捐衣' -->
  <div class="fastClothesWrap">
    <div class="searchBox">
      <button class="allBtnClass" @click="allChange()">全部</button>
      <div class="selectBox">
        <div class="selectClass" @click="isSexShow = !isSexShow">
          {{ curSexSelect }}
          <img src="https://img.bbalt.cn/imgh5/donate/icon_narrow_down.svg" alt="" />
        </div>
        <ul v-show="isSexShow">
          <li
            :value="item"
            v-for="(item, index) in sexOptionList"
            :key="index"
            @click="handleChange('性别', item)"
          >
            {{ item }}
            <img
              v-if="item === curSexSelect"
              src="https://img.bbalt.cn/imgh5/donate/icon_tick.svg"
              alt=""
            />
          </li>
        </ul>
      </div>
      <div class="selectBox">
        <div class="selectClass" @click="isSeasonShow = !isSeasonShow">
          {{ curSeasonSelect }}
          <img src="https://img.bbalt.cn/imgh5/donate/icon_narrow_down.svg" alt="" />
        </div>
        <ul v-show="isSeasonShow">
          <li
            :value="item"
            v-for="(item, index) in seasonOptionList"
            :key="index"
            @click="handleChange('季节', item)"
          >
            {{ item }}
            <img
              v-if="item === curSeasonSelect"
              src="https://img.bbalt.cn/imgh5/donate/icon_tick.svg"
              alt=""
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="listBox">
      <div class="listClass" v-for="(item, index) in curDataList" :key="index">
        <h4>{{ item.sizeHeightName }}</h4>
        <ul>
          <li v-for="(subItem, subIndex) in item.contents" :key="subIndex">
            <div :class="setColor(subItem.seasonName)">
              {{ subItem.seasonName ? (subItem.seasonName.includes('春秋') ? subItem.seasonName.substring(0, 2) : subItem.seasonName.substring(0, 1)) : "" }}
            </div>
            <div class="infoBox">
              <span>{{ subItem.sexName }}&nbsp; {{ subItem.seasonName }}</span>
              <span>总缺 {{ subItem.insufficiency }} 件</span>
            </div>
            <div class="countBox">
              <img
                :src="
                  `https://img.bbalt.cn/imgh5/donate/icon_minus${
                    subItem.count === 0 ? '' : '_act'
                  }.svg`
                "
                alt=""
                @click="
                  () => {
                    subItem.count--;
                    subItem.count < 0 && (subItem.count = 0);
                  }
                "
              />
              <input
                type="tel"
                class="numberboxClass"
                v-model="subItem.count"
                @mousedown="curCount = subItem.count"
                @mouseleave="handleCount(index, subIndex, subItem.count)"
              />
              <img
                src="https://img.bbalt.cn/imgh5/userCenter/icon_add.svg"
                alt=""
                @click="subItem.count++"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btnBox">
      <button class="btnDonateClass" @click="handleDonate()">立即捐赠</button>
    </div>
  </div>
</template>

<script>
import { fastClothes } from "@/api/donate";
import { myDonatemMatch } from "@/api/other.js";

export default {
  components: {},
  data() {
    return {
      sexOptionList: ["男", "女", "取消选中"],
      seasonOptionList: ["春秋装", "夏装", "冬装", "取消选中"],
      curSexSelect: "性别",
      curSeasonSelect: "季节",
      isSexShow: false,
      isSeasonShow: false,
      curDataList: [],
    };
  },
  created() {
    this.getFastClothes();
  },
  methods: {
    handleChange(type, curSelect) {
      if (type === "性别") {
        if (curSelect === "取消选中") {
          this.curSexSelect = "性别";
        } else {
          this.curSexSelect = curSelect;
        }
      } else {
        if (curSelect === "取消选中") {
          this.curSeasonSelect = "季节";
        } else {
          this.curSeasonSelect = curSelect;
        }
      }

      this.isSexShow = false;
      this.isSeasonShow = false;
      this.getFastClothes();
    },
    allChange() {
      this.isSexShow = false;
      this.isSeasonShow = false;
    },
    setColor(item) {
      if (item.includes("冬装")) {
        return "color0 shortTitle";
      } else if (item.includes("春秋")) {
        return "color1 shortTitle";
      } else {
        return "color2 shortTitle";
      }
    },
    async getFastClothes() {
      const { content } = await fastClothes({
        season: this.curSeasonSelect !== "季节" ? this.curSeasonSelect : "",
        sex: this.curSexSelect !== "性别" ? this.curSexSelect : "",
      });
      this.curDataList = content.map((item) => {
        item.contents.forEach((subItem) => {
          subItem.count = 0;
        });
        return item;
      });
    },
    handleCount(index, subIndex, val) {
      if (val < 0 || !Number(val)) {
        this.curDataList[index].contents[subIndex].count = 0;
      }
    },
    async handleDonate() {
      let tempData = [];
      this.curDataList.map((item) => {
        item.contents.map((subItem) => {
          if (subItem.count > 0) {
            tempData.push({
              categoryId: "",
              donateCount: subItem.count,
              goodsId: "",
              season: subItem.season,
              sex: subItem.sex,
              sizeHeight: subItem.sizeHeight
            });
          }
        });
      });

      if (tempData.length > 0) {
        const { code, message, content } = await myDonatemMatch({
          type: 1,
          detailArgList: tempData,
        });
        if (code === 200) {
          this.$router.push({
            path: "/userCenterThird",
            query: { title: "可捐衣物匹配", data: JSON.stringify(content), donateType: 1, code: content.code },
          });
        } else {
          this.$toast.fail(message);
        }
      } else {
        this.$toast.fail("请选择要匹配的数据");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fastClothesWrap {
  height: 80vh;
  width: 100%;
  overflow: auto;
  padding-bottom: 37px;
  border-top: 1px solid #ededed;
  .searchBox {
    margin: 22px 32px 15px 32px;
    display: flex;
    justify-content: space-between;
    .allBtnClass {
      width: 178px;
      height: 72px;
      background: #eeeeee;
      border-radius: 36px;
      border: 1px solid #dddddd;
    }

    .selectBox {
      width: 180px;
      height: 72px;
      position: relative;
      .selectClass {
        background: #eeeeee;
        border-radius: 36px;
        border: 1px solid #dddddd;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          margin-left: 8px;
        }
      }
      ul {
        position: absolute;
        top: 88px;
        left: -30px;
        width: 208px;
        background: #eeeeee;
        border-radius: 24px;
        display: flex;
        flex-flow: column;
        li {
          padding-left: 32px;
          margin: 18px 0px;
          height: 36px;
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          padding-right: 16px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }

  .listBox {
    font-family: PingFangSC, PingFang SC;
    max-height: 76%;
    overflow-y: auto;
    .listClass {
      h4 {
        margin: 15px 0px 15px 32px;
        height: 34px;
        font-size: 26px;
        font-weight: 400;
        color: #666666;
        line-height: 34px;
      }
      ul {
        width: 100%;
        background: #ffffff;
        display: flex;
        flex-flow: column;
        li {
          display: flex;
          justify-self: flex-start;
          align-items: center;
          height: 128px;
          border-bottom: 1px solid #ededed;
          margin: 0px 32px;
          .shortTitle {
            width: 80px;
            height: 80px;
            font-size: 30px;
            font-weight: 400;
            line-height: 80px;
            text-align: center;
            border-radius: 50%;
            margin-right: 32px;
          }
          .infoBox {
            display: flex;
            flex-flow: column;
            width: 55%;
            span {
              font-size: 26px;
              font-weight: 400;
              &:first-child {
                color: #333333;
                margin-bottom: 4px;
              }
              &:last-child {
                color: #999999;
              }
            }
          }
          .countBox {
            width: 164px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
            }
            .numberboxClass {
              width: 56px;
              height: 36px;
              background: #f5f5f5;
              border-radius: 2px;
              border: none;
              text-align: center;
            }
          }
        }
      }
    }
  }
  .btnBox {
    margin-top: 24px;
    display: flex;
    justify-content: center;

    button {
      width: 335px;
      height: 96px;
      background: #ffffff;
      border-radius: 48px;
      border: 2px solid #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 30px;
      font-weight: 400;
      color: #333333;
      img {
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      &.btnDonateClass {
        background: #fe66a6;
        font-size: 32px;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .fixBox {
    width: calc(100% - 40px);
    height: 124px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/bg_fix.png");
    background-repeat: no-repeat;
    background-size: 100% 124px;
    margin: 0px 20px;
    position: fixed;
    bottom: 170px;
    .titleBox {
      margin-top: 23px;
      margin-left: 52px;
      height: 40px;
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        &:first-child {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
        &:last-child {
          width: 30px;
          height: 30px;
          margin-left: 24px;
        }
      }
    }
    p {
      margin-top: 9px;
      margin-left: 52px;
      height: 28px;
      font-size: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
    }
  }

  // 冬季颜色
  .color0 {
    color: #679fd2;
    background-color: rgba(103, 159, 210, 0.16);
  }

  // 夏季颜色
  .color2 {
    color: #EC71A4;
    background-color: #FBF0F6;
  }

  // 春秋颜色
  .color1 {
    color: #F2A361;
    background-color: #FCEFCF;
  }
}
</style>
